import Model from './model.js'
// import {RequestinProcess,AddPaginationURL} from '../../helper/request.action.js'
export default {
  ReadVendor:function(params){
      if (params.is_props_field){
        Model.ReadAsMaster(params)
        return
      }
      // if(params.action == 'Next'){
      //   params.data.url = params.Reducer.next
      // }else if(params.action == 'Previous'){
      //   params.data.url = params.Reducer.previous
      // }
      // params.RunRedux(RequestinProcess({in_process:true,type:"READ"}))
      // Model.Read(params)
  },
}



// WEBPACK FOOTER //
// ./src/App/master/vendor/presenter.js